angular.module('lead-bant')
    .component('leadBantBtnOptions', {
        bindings: {
            item: '<',
            largeButton: '<'
        },
        templateUrl: 'app/lead/bant/_btn-options.html',
        controller: function ($rootScope, LeadBantService) {
            this.LeadBantService = LeadBantService

            this.delete = () => LeadBantService.delete(this.item)
        }
    })
